// Simple TMDB API test utility
import { searchMovies, getMovieDetails, extractMovieInfo } from '../services/tmdbService';

export const testTMDBConnection = async () => {
  console.log('🎬 Testing TMDB API connection...');
  
  try {
    // Test search
    const searchResults = await searchMovies('The Exorcist', 1973);
    if (!searchResults || searchResults.length === 0) {
      throw new Error('No search results found');
    }
    
    console.log('✅ Search successful:', searchResults[0].title);
    
    // Test detailed movie info
    const movieDetails = await getMovieDetails(searchResults[0].id);
    if (!movieDetails) {
      throw new Error('Could not fetch movie details');
    }
    
    const movieInfo = extractMovieInfo(movieDetails);
    console.log('✅ Movie details fetched:', {
      title: movieInfo.title,
      year: new Date(movieInfo.releaseDate).getFullYear(),
      runtime: movieInfo.runtime,
      director: movieInfo.director,
      hasPoster: !!movieInfo.posterUrl,
      hasTrailer: !!movieInfo.trailerUrl
    });
    
    console.log('🎉 TMDB API integration is working perfectly!');
    return true;
    
  } catch (error) {
    console.error('❌ TMDB API test failed:', error.message);
    return false;
  }
};

// Test with a horror movie
export const testHorrorMovie = async () => {
  console.log('🎃 Testing with a horror movie...');
  
  try {
    const movieDetails = await searchMovies('Halloween', 1978);
    if (movieDetails && movieDetails.length > 0) {
      const details = await getMovieDetails(movieDetails[0].id);
      const info = extractMovieInfo(details);
      
      console.log('🔪 Horror movie test result:', {
        title: info.title,
        plot: info.plot?.substring(0, 100) + '...',
        posterUrl: info.posterUrl,
        trailerUrl: info.trailerUrl,
        director: info.director,
        stars: info.stars?.slice(0, 3)
      });
      
      return info;
    }
  } catch (error) {
    console.error('❌ Horror movie test failed:', error);
  }
  
  return null;
};
